<template>
  <div class="app-header">
    <!-- 信息条 -->
    <div class="info-bar">
      <div class="brand"><span class="logo-mark">MJ</span><span class="logo-text">名爵</span></div>
      <div class="marquee"><i class="mq-icon notice-horn" title="线路切换" @click="dlg.line = true" /><div class="mq-track"><span>{{ notice }}</span></div></div>
      <a class="more" @click="dlg.notice = true">更多&gt;&gt;</a>
      <div class="room">
        <span>房间号: {{ room.id || '—' }}</span>
        <span>房间名称: {{ room.name || '—' }}</span>
        <span>过期时间: {{ room.expireAt || '—' }}</span>
      </div>
      <div class="acts">
        <span class="fb-btn" @click="dlg.feedback = true"><Icon type="ios-create-outline" /> 反馈</span>
        <Badge dot><Icon class="bell" type="ios-notifications-outline" /></Badge>
        <span class="chip green" @click="dlg.download = true"><Icon type="ios-cloud-download-outline" /> H5/APP 下载</span>
        <Dropdown @on-click="onMenu">
          <span class="account"><i class="avatar"><Icon type="ios-contact" /></i> {{ user.name || 'tx0120' }} <Icon type="ios-arrow-down" /></span>
          <template #list>
            <DropdownMenu>
              <DropdownItem name="pwd">修改登录密码</DropdownItem>
              <DropdownItem name="safepwd">设置安全密码</DropdownItem>
              <DropdownItem name="2fa">二次验证</DropdownItem>
              <DropdownItem name="logout" divided>退出</DropdownItem>
            </DropdownMenu>
          </template>
        </Dropdown>
      </div>
    </div>

    <!-- 横向图标菜单 -->
    <div class="menu-bar">
      <div class="menus">
        <div v-for="m in menus" :key="m.name" class="menu" :class="{ active: $route.name === m.name }"
          @click="go(m)">
          <Badge v-if="m.hot" text="HOT" class="hotbadge"><i class="menu-icon" :class="m.ic" /></Badge>
          <i v-else class="menu-icon" :class="m.ic" />
          <span>{{ m.title }}</span>
        </div>
      </div>
      <div class="audit" @click="auditShow = true">
        <Icon type="ios-arrow-dropright-circle" /> 审核
      </div>
    </div>

    <!-- 审核抽屉(右侧滑入,近全宽对齐截图) -->
    <Drawer title="审核" :width="1480" v-model="auditShow" :styles="{ padding: '12px' }">
      <div class="audit-sum">总上分 <b>0</b> / 总下分 <b>0</b></div>
      <table class="audit-tbl">
        <thead><tr><th>用户名</th><th>会员备注</th><th>操作类型</th><th>操作备注</th><th>交易信息</th><th>金额</th><th>时间</th><th>状态</th><th>操作</th></tr></thead>
        <tbody><tr><td colspan="9" class="empty">暂无数据</td></tr></tbody>
      </table>
      <div class="audit-pager">
        <span class="ap-info">页码 1/0 共 0 条</span>
        <Select :value="15" size="small" class="ap-size">
          <Option :value="15">15条/页</Option><Option :value="30">30条/页</Option>
          <Option :value="50">50条/页</Option><Option :value="100">100条/页</Option>
        </Select>
        <Button size="small">上一页</Button>
        <Button size="small">下一页</Button>
        <Input :value="1" size="small" class="ap-jump" />
        <Button type="primary" size="small">跳转</Button>
      </div>
    </Drawer>

    <!-- 全局弹窗 -->
    <change-password-dialog v-model="dlg.pwd" />
    <set-safe-password-dialog v-model="dlg.safepwd" />
    <two-factor-dialog v-model="dlg.tfa" />
    <download-dialog v-model="dlg.download" />
    <feedback-dialog v-model="dlg.feedback" />
    <update-room-dialog v-model="dlg.room" />
    <notice-dialog v-model="dlg.notice" />
    <line-switch-dialog v-model="dlg.line" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { fetchRoomInfo } from '@/api/room'
import { fetchAdminNotices } from '@/api/notice'
import ChangePasswordDialog from '@/components/dialogs/ChangePasswordDialog.vue'
import SetSafePasswordDialog from '@/components/dialogs/SetSafePasswordDialog.vue'
import TwoFactorDialog from '@/components/dialogs/TwoFactorDialog.vue'
import DownloadDialog from '@/components/dialogs/DownloadDialog.vue'
import FeedbackDialog from '@/components/dialogs/FeedbackDialog.vue'
import UpdateRoomDialog from '@/components/dialogs/UpdateRoomDialog.vue'
import NoticeDialog from '@/components/dialogs/NoticeDialog.vue'
import LineSwitchDialog from '@/components/dialogs/LineSwitchDialog.vue'

export default {
  name: 'AppHeader',
  components: { ChangePasswordDialog, SetSafePasswordDialog, TwoFactorDialog, DownloadDialog, FeedbackDialog, UpdateRoomDialog, NoticeDialog, LineSwitchDialog },
  data() {
    return {
      notice: '', // 真公告由 loadNotices() 从 /notice/list 拉取;无公告则留空(不再写死假文案)
      auditShow: false,
      dlg: { pwd: false, safepwd: false, tfa: false, download: false, feedback: false, room: false, notice: false, line: false },
      menus: [
        { name: 'home', title: '首页', ic: 'home' },
        { name: 'system', title: '系统设置', ic: 'system' },
        { name: 'wallet', title: '钱包', ic: 'wallet' },
        { name: 'user', title: '用户管理', ic: 'user' },
        { name: 'apply', title: '申请管理', ic: 'apply' },
        { name: 'report', title: '报表', ic: 'report' },
        { name: 'activity', title: '活动管理', ic: 'promotions' },
        { name: 'monitor', title: '现场监控', ic: 'monitor' },
        { name: 'quota', title: '赔率限额', ic: 'quota' },
        { name: 'makeoffer', title: '打盘报表', ic: 'makeAnOffer' },
        { name: 'open', title: '开奖结果', ic: 'open' },
        { name: 'kj163', title: '163开奖网', ic: 'open163', external: 'https://163kk.com' },
        { name: 'game', title: '娱乐游戏', ic: 'threeGame' },
        { name: 'liang', title: '靓号活动', ic: 'roomNum', hot: true }
      ]
    }
  },
  computed: { ...mapState(['room', 'user']) },
  created() {
    this.loadRoomInfo()
    this.loadNotices()
  },
  methods: {
    // 房间信息条(房间名/过期时间)+ 左栏上次登录(admin_last_login 存入 store.room.lastLogin)。
    // 登录响应不含 expire_at,故顶栏过期时间必须来自 /room/info。
    loadRoomInfo() {
      fetchRoomInfo().then((d) => {
        if (!d) return
        this.$store.commit('setRoom', {
          id: d.room_code || this.room.id,
          name: d.room_name || this.room.name,
          expireAt: d.expire_at || '',
          lastLogin: d.admin_last_login || '',
          logo: d.avatar || d.logo_url || '' // 群主头像兜底(聊天右侧系统/群主消息用)
        })
      }).catch(() => {})
    },
    // 跑马灯公告:真公告拼接展示;为空则保留默认文案(dev 房无公告)。
    loadNotices() {
      fetchAdminNotices().then((list) => {
        if (!Array.isArray(list) || !list.length) return
        const text = list.map((n) => n.content || n.title).filter(Boolean).join('　　')
        if (text) this.notice = text
      }).catch(() => {})
    },
    go(m) {
      if (m.external) { window.open(m.external, '_blank'); return }
      if (this.$route.name !== m.name) this.$router.push({ name: m.name }).catch(() => {})
    },
    onMenu(name) {
      if (name === 'pwd') this.dlg.pwd = true
      else if (name === 'safepwd') this.dlg.safepwd = true
      else if (name === '2fa') this.dlg.tfa = true
      else if (name === 'logout') { this.$store.commit('setUser', { token: '' }); this.$router.replace('/login') }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/tokens.less';
.app-header { position: sticky; top: 0; z-index: 100; }
// 信息条
.info-bar {
  height: @topbar-h; display: flex; align-items: center; gap: 14px; padding: 0 16px;
  background: @header-bg; color: #fff; font-size: 13px;
}
.brand { display: flex; align-items: center; gap: 6px; font-weight: 700; }
.brand .logo-mark { background: #fff; color: @primary; border-radius: 5px; padding: 1px 5px; font-size: 13px; }
.brand .logo-text { font-size: 18px; }
.marquee { flex: 1; display: flex; align-items: center; gap: 6px; overflow: hidden; color: @marquee; font-weight: 600; }
.marquee .mq-icon { color: #fff; position: relative; z-index: 2; flex-shrink: 0; cursor: pointer; }
.marquee .notice-horn { display: inline-block; width: 24px; height: 20px; background-image: url("data:image/png;base64,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"); background-size: contain; background-repeat: no-repeat; background-position: center; }
.mq-track { flex: 1; overflow: hidden; white-space: nowrap; }
.mq-track span { display: inline-block; animation: marquee 18s linear infinite; }
@keyframes marquee { from { transform: translateX(20%);} to { transform: translateX(-100%);} }
.more { color: #fff; opacity: .9; }
.room { display: flex; gap: 14px; opacity: .95; }
.acts { display: flex; align-items: center; gap: 12px; }
.acts .chip { display: inline-flex; align-items: center; gap: 3px; cursor: pointer; background: rgba(255,255,255,.16); padding: 3px 8px; border-radius: 4px; }
.acts .chip.green { background: @h5green; }
// 反馈:浅青底 + 青边(对齐真实)
.acts .fb-btn { display: inline-flex; align-items: center; gap: 3px; cursor: pointer;
  background: #D5FAFE; color: #0e93a8; border: 1px solid #23CAEA; padding: 3px 10px; border-radius: 4px; }
.acts .bell { font-size: 18px; }
.acts .account { display: inline-flex; align-items: center; gap: 5px; cursor: pointer; }
.acts .avatar { width: 24px; height: 24px; border-radius: 50%; background: rgba(255,255,255,.9); color: @primary;
  display: inline-flex; align-items: center; justify-content: center; font-size: 16px; overflow: hidden; }
// 图标菜单
.menu-bar {
  height: @menu-h; display: flex; align-items: center; justify-content: space-between;
  background: @bg-white; border-bottom: 1px solid @border; padding: 0 0 0 16px; box-shadow: 0 1px 4px rgba(0,0,0,.04);
}
.menus { display: flex; align-items: stretch; overflow-x: auto; }
.menu {
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px;
  min-width: 66px; height: @menu-h; cursor: pointer; color: @text-sub; font-size: 12px; border-bottom: 2px solid transparent;
}
.menu:hover { color: @primary; }
.menu.active { color: @primary; background: @primary-light; border-bottom-color: @primary; }
.audit {
  display: flex; align-items: center; gap: 4px; color: #fff; cursor: pointer; flex-shrink: 0;
  background: linear-gradient(90deg, @orange1, @orange2); padding: 8px 22px; border-radius: 20px 0 0 20px; font-weight: 600;
}
.audit-sum { margin-bottom: 10px; color: @text-sub; }
.audit-sum b { color: @primary; }
.audit-tbl { width: 100%; border-collapse: collapse; font-size: 12px; }
.audit-tbl th { background: @row-alt; color: @text-sub; padding: 8px 6px; border-bottom: 1px solid @border-light; }
.audit-tbl td { padding: 8px 6px; }
.audit-tbl .empty { text-align: center; color: @text-muted; padding: 50px 0; }
.audit-pager { display: flex; align-items: center; justify-content: flex-end; gap: 8px; margin-top: 12px; }
.audit-pager .ap-info { color: @text-sub; font-size: 12px; }
.audit-pager .ap-size { width: 96px; }
.audit-pager .ap-jump { width: 50px; }
</style>
